import React from 'react'
import { Grid, Button, Stack } from '@mui/material'
import getBookByIsbn from '../../services/GetBookByIsbn'
import { object, func } from 'prop-types'
import SmallTextField from '../textfield/SmallTextfield'
import Dater from '../../services/DateFormat'

const IsbnForm = ({ form, handleChange, onFormChange, close }) => {
  const bookData = book => {
    if (book !== null) {
      const { volumeInfo } = book

      onFormChange({
        ...form,
        titulo: volumeInfo.title,
        subTitulo: volumeInfo?.volumeInfo || undefined,
        numero_pagina: volumeInfo.pageCount,
        data_publicacao: validateGoogleBooksDate(volumeInfo.publishedDate),
        autores: volumeInfo?.authors?.join(', ') || '',
        editora: volumeInfo?.publisher || ''
      })
    }
  }

  const validateGoogleBooksDate = date => {
    if (date === null || date === undefined) {
      return Dater().formatar(new Date(), 'yyyy-mm-dd')
    } else {
      if (date.length) {
        if (date.length <= 4) {
          return Dater().formatar(new Date(date), 'yyyy') + '-01-01'
        }
        return Dater().formatar(new Date(date), 'yyyy-mm-dd')
      }
    }
  }
  return (
    <form>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <SmallTextField
            onBlur={async ({ target }) => {
              if (target.value.length > 9) {
                const result = await getBookByIsbn(target.value)
                bookData(result)
              }
            }}
            name="isbn"
            label="ISBN"
            value={form.isbn}
            onChange={({ target }) =>
              onFormChange({ ...form, isbn: target.value })
            }
            required
            maxLength={12}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SmallTextField
            label="Título"
            onChange={({ target }) =>
              onFormChange({ ...form, titulo: target.value })
            }
            value={form.titulo}
            upperCase
          />
        </Grid>
      </Grid>

      <Stack
        direction="row"
        spacing={1}
        sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}
      >
        <Button onClick={() => close(false)} variant="outlined" color="error">
          Fechar
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="leitura"
          onClick={e => handleChange(e, 1)}
        >
          Próximo
        </Button>
      </Stack>
    </form>
  )
}

IsbnForm.propTypes = {
  form: object.isRequired,
  handleChange: func,
  onFormChange: func,
  close: func
}

export default IsbnForm
